import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ShoppingCartType } from "../../../(general-header)/header/types";

type CartState = {
  isCartOpen: boolean;
  cartData: ShoppingCartType;
};

const initialState: CartState = {
  isCartOpen: false,
  cartData: null,
};

export const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    publishCartState: (state, action: PayloadAction<{ isOpen: boolean }>) => {
      state.isCartOpen = action.payload.isOpen;
    },
    publishCartData: (state, action: PayloadAction<{ cartData: ShoppingCartType }>) => {
      state.cartData = action.payload.cartData;
    },
  },
});

export const { publishCartState, publishCartData } = cartSlice.actions;

export default cartSlice.reducer;
